import {
  LocationType,
} from 'Generated/graphql';

export const DefaultServiceAreaName: Record<LocationType, string> = {
  [LocationType.Partner]: 'In-Suite',
  [LocationType.Business]: 'Lobby',
  [LocationType.ServiceProvider]: '',
  [LocationType.Individual]: 'Residence',
  [LocationType.IndividualWork]: 'Lobby',
  [LocationType.IndividualIndeterminate]: 'Residence',
  [LocationType.ServiceProviderRetail]: 'Reception Area',
};
